<template>
  <div>
      <client-list :user="user" :current-team="currentTeam" v-show="viewList"></client-list>
      <client-breadcrumbs v-show="viewBreadcrumbs"></client-breadcrumbs>
      <client-profile :user="user" v-show="viewProfile"></client-profile>
      <budget-group-details-view v-show="viewBudgetGroupDetails"></budget-group-details-view>
      <ad-account-details-view v-show="viewAdAccountDetails"></ad-account-details-view>
      <ga-view-details-view v-show="viewGaViewDetails"></ga-view-details-view>
      <call-platform-details-view v-show="viewCallPlatformDetails"></call-platform-details-view>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import GaViewDetailsView from './GaViewDetailsView.vue';
import BudgetGroupDetailsView from './BudgetGroupDetailsView.vue';
import CallPlatformDetailsView from './CallPlatformDetailsView.vue';
import ClientList from './ClientList.vue';
import AdAccountDetailsView from './AdAccountDetailsView.vue';
import ClientProfile from './ClientProfile.vue';
import ClientBreadcrumbs from './ClientBreadcrumbs.vue';

export default {
    components: {
        ClientList,
        BudgetGroupDetailsView,
        GaViewDetailsView,
        AdAccountDetailsView,
        ClientProfile,
        ClientBreadcrumbs,
        CallPlatformDetailsView,
    },

    props: ['user','currentTeam'],

    computed: {
        ...mapGetters('client', {
            'isAdmin': 'isAdmin',
            'view': 'view'
        }),

        viewList() {
            return this.view.active === 'list';
        },

        viewBreadcrumbs() {
            return this.view.active !== 'list';
        },

        viewProfile() {
            return this.view.active === 'profile';
        },

        viewBudgetGroupDetails() {
            return this.view.active === 'budget_group_details';
        },

        viewAdAccountDetails() {
            return this.view.active === 'ad_account_details';
        },

        viewGaViewDetails() {
            return this.view.active === 'ga_view_details';
        },

        viewCallPlatformDetails() {
            return this.view.active === 'call_platform_details';
        },
    },

    created() {
        var self = this;

        Bus.$on('sparkHashChanged', function (hash, parameters) {
            if (hash != 'clients') {
                return true;
            }

            if (parameters && (parameters.length === 1 || (parameters.length === 2 && parameters[1] === ''))) {
                history.pushState(null, null, '#/clients/' + parameters[0]);
                self.$store.dispatch('client/showClientProfile');
                self.loadClientProfile({ slug: parameters[0] });
            } else if (parameters && parameters.length === 3 && parameters[1] === 'ad-accounts') {
                history.pushState(null, null, `#/clients/${parameters[0]}/ad-accounts/${parameters[2]}`);
                self.$store.dispatch('client/showClientProfile');
                self.$store.dispatch('client/getClientInfo', {
                    client:  parameters[0]
                }).then(() => self.showAccountData({account_id: parameters[2]}));
            } else if (parameters && parameters.length === 3 && parameters[1] === 'ga-views') {
                history.pushState(null, null, `#/clients/${parameters[0]}/ga-views/${parameters[2]}`);
                self.$store.dispatch('client/showClientProfile');
                self.$store.dispatch('client/getClientInfo', {
                    client:  parameters[0]
                }).then(() => self.showViewData({view_id: parameters[2]}));
            } else if (parameters && parameters.length === 3 && parameters[1] === 'call-platforms') {
                history.pushState(null, null, `#/clients/${parameters[0]}/call-platforms/${parameters[2]}`);
                self.$store.dispatch('client/showClientProfile');
                self.$store.dispatch('client/getClientInfo', {
                    client:  parameters[0]
                }).then(() => self.showCallPlatformData({account_id: parameters[2]}));
            } else if (parameters && parameters.length === 3 && parameters[1] === 'budget-groups') {
                history.pushState(null, null, `#/clients/${parameters[0]}/budget-groups/${parameters[2]}`);
                self.$store.dispatch('client/showClientProfile');
                self.$store.dispatch('client/getClientInfo', {
                    client:  parameters[0]
                }).then(() => self.showBudgetGroupData({id: parameters[2]}));
            } else {
                self.$store.dispatch('client/showClientListView');
            }

            return true;
        });

        Bus.$on('client-added', function(client) {
            $('#modal-new-client-form').modal('hide');
            self.showClientInfo(client);
        });
    },
    methods: {
        prepareComponent() {
            this.setPermissions();
            this.setCurrentTeam();
        },

        ...mapActions('client',{
            'getClientList': 'getAllClients',
        }),

        setCurrentTeam() {
            this.$store.dispatch('client/setCurrentTeam', {
                team: this.currentTeam
            });
        },

        setPermissions() {
            this.$store.dispatch('client/setAuth', {
                auth: this.user.teams[0].pivot
            });
        },

        showAccountData(account) {
            this.$store.dispatch('client/showAccountDetails', {
                account: account
            });
            Bus.$emit('load-campaign-list');
            Bus.$emit('load-conversion-list');
        },

        showViewData(view) {
            this.$store.dispatch('client/showViewDetails', {
                view: view
            });
            Bus.$emit('load-ga-goal-list');
        },

        showCallPlatformData(platform) {
            this.$store.dispatch('client/showCallPlatformDetails', {
                platform: platform
            });
        },

        showBudgetGroupData(group) {
            this.$store.dispatch('client/showBudgetGroupDetails', {
                group: group
            });
        },

        showClientInfo(client) {
            history.pushState(null, null, '#/clients/' + client.slug);
            this.$store.dispatch('client/showClientProfile');
            this.loadClientProfile(client);
        },

        loadClientProfile(client) {
            Bus.$emit('load-client-profile', client.slug);
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/ClientView.vue